import UIDs from "../../../../UIDs";

const uid = UIDs.screens.homework.newlist;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    UPDATE_SCREEN_IN_BACKGROUND_ASYNC: `${uid}.updateScreenInBackgroundAsync`,
    UPDATE_SCREEN_IN_BACKGROUND_SUCCESS: `${uid}.updateScreenInBackgroundSuccess`,
    UPDATE_SCREEN_IN_BACKGROUND_FAILURE: `${uid}.updateScreenInBackgroundFailure`,
    REFRESH_SCREEN_ASYNC: `${uid}.refreshScreenAsync`,
    REFRESH_SCREEN_SUCCESS: `${uid}.refreshScreenSuccess`,
    REFRESH_SCREEN_FAILURE: `${uid}.refreshScreenFailure`,
    LOAD_MORE_ASYNC: `${uid}.loadMoreAsync`,
    LOAD_MORE_SUCCESS: `${uid}.loadMoreSuccess`,
    LOAD_MORE_FAILURE: `${uid}.loadMoreFailure`,
    LOAD_HOMEWORK_DATA_ASYNC: `${uid}.loadHomeworkDataAsync`,
    LOAD_HOMEWORK_DATA_SUCCESS: `${uid}.loadHomeworkDataSuccess`,
    LOAD_HOMEWORK_DATA_FAILURE: `${uid}.loadHomeworkDataFailure`,
    REPORT_OFFLINE_PROBLEM_ASYNC: `${uid}.reportOfflineProblemAsync`,
    REPORT_OFFLINE_PROBLEM_SUCCESS: `${uid}.reportOfflineProblemSuccess`,
    REPORT_OFFLINE_PROBLEM_FAILURE: `${uid}.reportOfflineProblemFailure`,
    START_BATCH_DOWNLOAD_DATA_ASYNC: `${uid}.startBatchDownloadDataAsync`,
    START_BATCH_DOWNLOAD_DATA_SUCCESS: `${uid}.startBatchDownloadDataSuccess`,
    START_BATCH_DOWNLOAD_DATA_FAILURE: `${uid}.startBatchDownloadDataFailure`,
    ADD_HOMEWORK_DOWNLOAD_TASKS: `${uid}.addHomeworkDownloadTasks`,
};

export { ActionTypes };
